module.exports = __webpack_public_path__ + "static/media/icon-ft-on-dp.80625975.svg";